module.exports = __webpack_public_path__ + "static/media/zenpicture.41d6eb84.png";